// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__11bD9","icons":"Footer_icons__3aWbi"};